import React from "react";
import { AppStoreBadges } from "./AppStoreBadges";
import { LANDING } from "@/constants/testIds";
import { WEB_REGISTER_URL } from "@/constants/site";
import { captureEvent } from "@/lib/analytics";

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid={LANDING.finalCta}
      className="relative overflow-hidden bg-[#0A3B3B] text-white py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-kente opacity-[0.12] pointer-events-none" />
      <div className="absolute -top-32 -left-20 h-[420px] w-[420px] rounded-full bg-[#0E6B6B]/40 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 right-0 h-[420px] w-[420px] rounded-full bg-[#D96C4A]/20 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-bold text-[#FFD8A8]">Ready to begin</span>
            <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-semibold leading-[1.08] tracking-tight">
              Tomorrow’s decision starts with today’s record.
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
              Create the workspace, capture the first real transaction, and see what changes when the whole operation begins telling one consistent story.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col items-start lg:items-end gap-4">
            <div className="flex flex-wrap gap-3">
              <a
                href={WEB_REGISTER_URL}
                target="_blank"
                rel="noreferrer"
                data-testid={LANDING.ctaEarlyAccess}
                onClick={() => captureEvent("conversion_cta_clicked", { placement: "final_cta", destination: "web_register" })}
                className="inline-flex items-center rounded-full bg-[#FFD8A8] text-[#0A2424] px-6 py-3.5 text-base font-semibold hover:bg-white transition-colors"
              >
                Start my free trial
              </a>
              <a
                href="/contact"
                data-testid={LANDING.ctaTalkSales + "-final"}
                className="inline-flex items-center rounded-full border border-white/30 px-6 py-3.5 text-base font-semibold text-white hover:bg-white/10 transition-colors"
              >
                Ask a question
              </a>
            </div>
            <AppStoreBadges
              playId={LANDING.ctaFooterPlayBadge}
              storeId={LANDING.ctaFooterAppStoreBadge}
              placement="final_cta"
            />
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl">
          {[
            { k: "9", v: "Languages supported" },
            { k: "Web + mobile", v: "Work across devices" },
            { k: "Offline-ready", v: "Keep mobile work moving" },
            { k: "7 days", v: "Free trial period" },
          ].map((s) => (
            <div key={s.v}>
              <div className="font-display text-3xl md:text-4xl font-semibold text-[#FFD8A8]">{s.k}</div>
              <div className="text-sm text-white/70 mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
